(function () {
  var ROOT_SELECTOR = '[data-knee-timer], [data-nw-product-timer]';

  function padTwo(value) {
    return String(value).padStart(2, '0');
  }

  /** Milliseconds until next local midnight (timer resets daily). */
  function getMsUntilMidnight() {
    var now = new Date();
    var nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    return Math.max(0, nextMidnight.getTime() - now.getTime());
  }

  function getCountdownDiff(root) {
    var endAt = root.getAttribute('data-end-at');

    if (endAt) {
      var endDate = new Date(endAt);
      if (!Number.isNaN(endDate.getTime())) {
        return endDate.getTime() - Date.now();
      }
    }

    return getMsUntilMidnight();
  }

  function setSectionVisibility(root, visible) {
    var section = root.closest('.knee-timer');
    if (!section) return;

    section.hidden = !visible;
    document.documentElement.style.setProperty('--knee-timer-height', visible ? section.clientHeight + 'px' : '0px');
    document.dispatchEvent(new CustomEvent('nw:update-mobile-menu-drawer-top'));
  }

  function tick(root) {
    var diff = getCountdownDiff(root);
    var hideExpired = root.getAttribute('data-hide-expired') === 'true';

    if (diff <= 0) {
      if (hideExpired) {
        setSectionVisibility(root, false);
        return false;
      }

      diff = 0;
    } else {
      setSectionVisibility(root, true);
    }

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var daysEl = root.querySelector('[data-knee-timer-days]');
    var hoursEl = root.querySelector('[data-knee-timer-hours]');
    var minutesEl = root.querySelector('[data-knee-timer-minutes]');
    var secondsEl = root.querySelector('[data-knee-timer-seconds]');

    if (daysEl) daysEl.textContent = padTwo(days);
    if (hoursEl) hoursEl.textContent = padTwo(hours);
    if (minutesEl) minutesEl.textContent = padTwo(minutes);
    if (secondsEl) secondsEl.textContent = padTwo(seconds);

    return true;
  }

  function initRoot(root) {
    if (root._kneeTimerIntervalId) {
      window.clearInterval(root._kneeTimerIntervalId);
    }

    tick(root);

    root._kneeTimerIntervalId = window.setInterval(function () {
      if (!tick(root)) {
        window.clearInterval(root._kneeTimerIntervalId);
        root._kneeTimerIntervalId = null;
      }
    }, 1000);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    document.dispatchEvent(new CustomEvent('nw:update-mobile-menu-drawer-top'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
